module.exports = __webpack_public_path__ + "static/media/instructions_repeat.786c3fa9.mp3";